import { Glyph } from "@motleyhand/design"
import { Link } from "@tanstack/react-router"
import { scrollTopOnClick } from "@/utils"

export default function Footer() {
  return (
    <footer className="border-t border-border/40">
      <div className="mx-auto flex max-w-250 items-center justify-between px-6 py-6 text-sm text-muted-foreground">
        <div className="flex items-center gap-2">
          <Glyph variant="tricolor" size={14} />
          <span>
            By{" "}
            <a
              href="https://motleyhand.com"
              target="_blank"
              rel="noreferrer noopener"
              className="underline-offset-4 transition-colors hover:text-foreground hover:underline"
            >
              Motley Hand
            </a>
          </span>
        </div>
        <div className="flex gap-5">
          <Link
            to="/legal/$slug"
            params={{ slug: "terms" }}
            onClick={scrollTopOnClick}
            className="transition-colors hover:text-foreground"
          >
            Terms
          </Link>
          <Link
            to="/legal/$slug"
            params={{ slug: "privacy" }}
            onClick={scrollTopOnClick}
            className="transition-colors hover:text-foreground"
          >
            Privacy
          </Link>
          <Link
            to="/contact"
            onClick={scrollTopOnClick}
            className="transition-colors hover:text-foreground"
          >
            Contact
          </Link>
        </div>
      </div>
    </footer>
  )
}
